<template>
  <div class="container-fluid mb-5">
    <div class="row mb-lg-5">
      <div class="col-12">
        <h1 class="title orange">{{ title }}</h1>
        <h2 class="subtitle mb-4">{{ subtitle }}</h2>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title:    'Wo "parken" Sie Ihre Ersparnisse?',
      subtitle: 'Wählen Sie alle Punkte aus, die auf Sie zutreffen und bestätigen Sie Ihre Auswahl mit “Senden”',
      points:   0,
      items:    [
        {
          label:  'In einem Bausparvertrag',
          points: 5,
          id:     1,
          active: false
        },
        {
          label:  'Auf meinem Sparbuch',
          points: 0,
          id:     2,
          active: false
        },
        {
          label:  'Auf dem Girokonto',
          points: 2,
          id:     3,
          active: false
        },
        {
          label:  'In Aktien oder Investmentfonds',
          points: 10,
          id:     4,
          active: false
        },
        {
          label:  'In der Sofaritze',
          points: 0,
          id:     5,
          active: false
        },
        {
          label:  'Auf einem Tagesgeldkonto',
          points: 5,
          id:     6,
          active: false
        }
      ]
    }
  }
}
</script>
<style>
#app {
  font-family: "Open Sans Condensed", Helvetica, sans-serif;
}

#app .title {
  color:          rgb(235, 102, 21);
  font-size:      2.3rem;
  font-weight:    700;
  text-transform: uppercase;
}

#app .subtitle {
  font-size: 25px;
}

.text-orange {
  color: #dc6d31;
}

.ripple {
  animation:     pulse 1s infinite;
  border-radius: 0;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 0, 1);
  }
  50% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 50px rgba(255, 0, 0, 0);
  }
}
</style>
